import { render } from "./AddonView.vue?vue&type=template&id=061eb152&scoped=true&ts=true"
import script from "./AddonView.vue?vue&type=script&lang=ts"
export * from "./AddonView.vue?vue&type=script&lang=ts"

import "./AddonView.vue?vue&type=style&index=0&id=061eb152&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061eb152"]])

export default __exports__